// Ключ скоупа списка: стабильная строка из сущности и набора фильтров.
// Используется блочной пагинацией (`rtkq_block_pager`) и «спекулятивными
// страницами» (`speculative-pages`), чтобы кэш и счётчик страниц не путали
// разные наборы фильтров между собой.

export type ScopeKey = string;

// Стабильный генератор ключей скоупа (например: entity: 'championships', tournamentId, фильтры)
export function makeScopeKey(parts: Record<string, any>): ScopeKey {
  return Object.entries(parts)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([k, v]) => `${k}:${JSON.stringify(v)}`)
    .join('|');
}
